import { createFileRoute } from '@tanstack/react-router'

import { EvaluationsListPage } from '@/features/evaluations'
import { buildPageTitle } from '@/shared/lib/page-title'

export const Route = createFileRoute('/_authenticated/_main/avaliacoes/')({
  head: () => ({
    meta: [{ title: buildPageTitle('Avaliações') }]
  }),
  component: EvaluationsListPage
})
